<template>
  <div
    :style="{
      position: 'relative'
    }"
  >
    <div
      class="d-flex justify-center align-start align-self-start"
      :style="{
        padding: `${$getScaledCssValue('8px')} ${$getScaledCssValue('30px')}`,
        borderRadius: $getScaledCssValue('7px'),
        border: '1px solid #DBDBDB'
      }"
      tabindex="1"
      @click="menuOpen = !menuOpen"
    >
      <div class="text-p3">{{ label }}</div>
      <v-icon :size="20">mdi-menu-down</v-icon>
    </div>

    <div
      :style="{
        backgroundColor: 'white',
        padding: `${$getScaledCssValue('16px')} 0 ${$getScaledCssValue(
          '16px'
        )} ${$getScaledCssValue('16px')}`,
        visibility: menuOpen ? 'visible' : 'hidden',
        opacity: menuOpen ? 1 : 0,
        position: 'absolute',
        //top:$getScaledCssValue('100% - 7px'),
        zIndex: 2,
        boxShadow: `0 ${$getScaledCssValue('3px')} ${$getScaledCssValue(
          '6px'
        )} #00000029`,
        //width: '100%'
      }"
      tabindex="1"
      @blur="menuOpen = false"
    >
      <v-virtual-scroll
        :items="items"
        :height="$getScaledValue(256)"
        :item-height="$getScaledValue(32)"
        :width="200"
        :style="{
          scrollbarWidth: 'none'
        }"
      >
        <template #default="{ item }">
          <Checkbox
            :val="item"
            dense
            v-model="innerValue"
            color="green"
            class="checkbox"
            :style="{
              height: $getScaledCssValue('32px'),
              display: 'block'
            }"
          >
            <template #label>
              <div
                class="text-p5"
                :style="{
                  //width: $getScaledCssValue('127px'),
                  width:'140px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }"
              >
                {{ item }}
              </div>
            </template>
          </Checkbox>
        </template>
      </v-virtual-scroll>
    </div>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue';

export default {
  components: {
    Checkbox
  },
  props: {
    value: {
      default: null
    },
    items: {
      default: null
    },
    showSuccess: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      defualt: null
    }
  },
  data: () => ({
    menuOpen: false
  }),
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.checkbox::v-deep {
  & .v-input {
    margin-top: 0;
    padding-top: 0;
  }

  & .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
